import React from 'react';

const InvStructureIcon = () => {
  return (
    <span
      title={'Investment Structure'}
      className="solstice-icon- solstice-icon-bar-chart"
      style={{ color: '#757575', fontSize: '14px' }}
    />
  );
};

export default InvStructureIcon;
